var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"textContent",staticClass:"fe-text-body-xxs lg:fe-text-body-s",class:['fe-overflow-hidden', { 'fe-line-clamp-3': !_vm.isExpanded }]},[_vm._v(" "+_vm._s(_vm.content)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }